import { createAuthClient } from "better-auth/react";
import { jwtClient, emailOTPClient, adminClient } from "better-auth/client/plugins";
import type { Auth } from "./auth";

// In dev: better-auth is mounted on the Vite middleware at /api/auth/*.
// In prod: nginx proxies /api/* to the Go backend, so the auth endpoints
// are same-origin with the frontend. Default to window.location.origin so
// the client works in both environments; override via
// VITE_BETTER_AUTH_URL when the auth server is on a different origin
// (e.g. "https://auth.yayy.net").
const baseURL =
	import.meta.env.VITE_BETTER_AUTH_URL ??
	(typeof window !== "undefined" ? window.location.origin : "");

export const authClient = createAuthClient({
	baseURL,
	plugins: [jwtClient(), emailOTPClient(), adminClient()],
});

export type Session = Auth["$Infer"]["Session"];
